import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import { Typography } from "@mui/material";
import { sendSignInLinkToEmail } from "firebase/auth";
import { auth } from "utils/firebase";
import { useSuccess } from "hooks/SuccessContext";
import { useState } from "react";
import UserApi from "apis/UserApi";
import { useError } from "hooks/ErrorContext";
export const EmailInput = () => {
  const [schoolNum, setSchoolNum] = useState("");
  const { showMessage } = useSuccess();
  const { showError } = useError();


  const sendLoginEmail = async (schoolNum) => {
    try {

     const apiRes = await UserApi.sendSignInLink({ schoolNum });
     const email = apiRes.data;
      window.localStorage.setItem("emailForSignIn", email);
      showMessage("Sign-in link sent! Please check your inbox.");
    } catch (error) {
      if (error.message.includes('(auth/quota-exceeded).')) {
        showError( `${error.message}. Try login using email password`);
      }
    }
  };
  return (
    <MKBox pt={4} pb={3} px={3}>
      <Card
        sx={{
          backgroundColor: "#e4edff",
          padding: 2, // Equivalent to padding: 10px
          marginBlock: 2,
          textAlign: "center",
        }}
      >
        {" "}
        <Typography variant="h6" component="p">
          Please provide your school number. An email associated with this account will receive the
          OTP.
        </Typography>{" "}
      </Card>

      <MKBox component="form" role="form">
        <MKBox mb={2}>
          <MKInput
            label="School Number"
            fullWidth
            onChange={(e) => {
              setSchoolNum(e.target.value);
            }}
          />
        </MKBox>

        <MKBox mt={4} mb={1}>
          <MKButton variant="gradient" color="info" fullWidth onClick={() => sendLoginEmail(schoolNum)}>
            Verify
          </MKButton>
        </MKBox>
      </MKBox>
    </MKBox>
  );
};
